var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_vm._v(" salut le plouc ")])
}
var staticRenderFns = []

export { render, staticRenderFns }